<template>
  <j-select
    v-if="$vuetify.breakpoint.xsOnly"
    multiple
    combo-box
    chips
    simple-item
    solo
    hashtag
    :prepend-inner-icon="icon ? 'fa-hashtag' : ''"
    solo-inverted
    hide-details
    :items="getUniqueTagsWithoutHeader"
    :value="value"
    label="Mots clés"
    @change="onChange"
  ></j-select>
  <v-combobox
    class="custom-tag-combobox"
    v-else
    multiple
    chips
    deletable-chips
    solo
    :prepend-inner-icon="icon ? 'fa-hashtag' : ''"
    :solo-inverted="soloInverted"
    hide-details
    :items="getUniqueTags"
    :value="getSortedValue"
    label="Mots clés"
    autocomplete="off"
    :search-input.sync="searchInput"
    @change="onChange"
  >
    <template v-slot:selection="data">
      <div
        class="category-container"
        :class="{ 'category-first-tag': getCategoryIndex(data.item) === 0 }"
      >
        <v-row dense no-gutters
          ><span
            class="category-chip"
            v-if="
              getCategoryIndex(data.item) === 0 && getCategory(data.item) === ''
            "
            >Sans catégorie
          </span>
          <span
            class="category-chip"
            v-else-if="getCategoryIndex(data.item) === 0"
            >{{ getCategory(data.item) }}
          </span>
          <span v-else style="height: 9px;"></span
        ></v-row>
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="remove(data.item)"
        >
          <v-row dense no-gutters> {{ data.item }}</v-row>
        </v-chip>
      </div>
    </template>
  </v-combobox>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeTagsEditor",
  props: {
    value: {
      type: Array,
      required: true
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getRecipes",
      "getOrganisationId",
      "getStoreId",
      "getTagCategories"
    ]),
    getUniqueTags() {
      return [
        ...new Set([
          ...this.getTagCategories.map(x => this.getTagsAndHeaders(x)).flat(),
          { header: "sans catégorie" },
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat()
        ])
      ];
    },
    getUniqueTagsWithoutHeader() {
      return [
        ...new Set([
          ...this.getTagCategories.map(x => x.tags).flat(),
          ...this.getRecipes
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat(),
          ...this.getProducts
            .filter(x => x.data !== null)
            .map(x => x.data.tags)
            .flat()
        ])
      ];
    },
    getSortedValue() {
      const v = [...this.value].sort(
        (a, b) => this.getCategoryId(a) - this.getCategoryId(b)
      );
      return v;
    }
  },
  data() {
    return {
      searchInput: ""
    };
  },
  methods: {
    onChange(v) {
      this.searchInput = "";
      if (v.length > 0 && v.slice(-1)[0].charAt(0) === "#") {
        this.$emit("input", v);
      } else if (v.length > 0 && v.slice(-1)[0].charAt(0) !== "#") {
        v[v.length - 1] = `#${v.slice(-1)[0]}`;
        this.$emit("input", v);
      } else {
        this.$emit("input", v);
      }
    },
    remove(item) {
      const index = this.value.indexOf(item);
      if (index >= 0) this.value.splice(index, 1);
    },
    getTagsAndHeaders(category) {
      return [{ header: category.name }, ...category.tags];
    },
    getCategory(tag) {
      let c = "";
      this.getTagCategories.forEach(x => {
        if (x.tags.includes(tag) === true) {
          c = x.name;
        }
      });
      return c;
    },
    getCategoryId(tag) {
      let c = null;
      this.getTagCategories.forEach(x => {
        if (x.tags.includes(tag) === true) {
          c = x.id;
        }
      });
      return c;
    },
    getCategoryIndex(tag) {
      const a = this.getSortedValue.filter(
        x => this.getCategory(x) === this.getCategory(tag)
      );
      return a.indexOf(tag);
    }
  }
};
</script>

<style lang="scss">
.v-select-list {
  .v-subheader {
    text-transform: uppercase !important;
    font-weight: bold !important;
    background-color: rgba(0, 0, 0, 0.025);
  }
}
.category-chip {
  text-transform: uppercase !important;
  font-weight: 400 !important;
  font-size: 0.5rem !important;
  letter-spacing: 0.1em !important;
  line-height: 0.6rem;
  color: rgba(0, 0, 0, 0.85);
}
.category-container {
  color: rgba(0, 0, 0, 0.85);
  margin-top: 0.2rem;
  padding-left: 5px;
}
.category-first-tag {
  border-left: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
